<h3>Error Detail</h3>
@if (conversionErrorDetail()) {
  <div>
    <p>
      Id: {{conversionErrorDetail().id }}
    </p>
    <p>
      Date: {{conversionErrorDetail().dateUtc | date: 'dd.MM.yyyy HH:mm'}}
    </p>
    <p>
      Filename: {{conversionErrorDetail().fileName}}
    </p>
    @if (conversionErrorDetail().clientName) {
      <p>
        Client: {{conversionErrorDetail().clientName}}
      </p>
    }
    <p>
      Error Message:
    </p>
    <pre>{{conversionErrorDetail().errorMessage}}</pre>
    @if (conversionOptions()) {
      <p>
        Conversion Options:
      </p>
    }
    @if (conversionOptions()) {
      <pre>{{conversionOptions() | json}}</pre>
    }
    @if (conversionErrorDetail().fileIsPersistedToStorage) {
      <button mat-button (click)="downloadFile()">Download File</button>
    }
  </div>
}
